import React from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

const SponsorCard = ({ sponsor, index }) => {
  const handleClick = () => {
    if (sponsor.website) {
      window.open(sponsor.website, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{
        scale: 1.1,
        rotate: [0, -2, 2, 0],
        transition: { duration: 0.3 },
      }}
      onClick={handleClick}
      className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group relative overflow-hidden text-gray-800 dark:text-gray-200 border border-transparent dark:border-gray-700"
    >
      {/* Hover overlay */}
      <motion.div
        initial={{ opacity: 0 }}
        whileHover={{ opacity: 1 }}
        className="absolute inset-0 bg-gradient-to-t from-cycling-orange/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      />

      <motion.div whileHover={{ y: -5 }} className="text-center relative z-10">
        {/* Logo container */}
        <div className="w-full h-20 mb-4 flex items-center justify-center bg-gray-50 dark:bg-gray-700/50 rounded-lg group-hover:bg-gray-100 dark:group-hover:bg-gray-600 transition-colors duration-300 relative overflow-hidden">
          <motion.img
            whileHover={{ scale: 1.05 }}
            src={sponsor.logo}
            alt={`${sponsor.name} logo`}
            className="max-w-full max-h-full object-contain transition-transform duration-300 mix-blend-multiply dark:mix-blend-normal"
            loading="lazy"
          />

          {/* External link icon - appears on hover */}
          {sponsor.website && (
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              whileHover={{ opacity: 1, scale: 1 }}
              className="absolute top-2 right-2 bg-cycling-orange text-white p-1 rounded-full"
            >
              <ExternalLink className="w-3 h-3" />
            </motion.div>
          )}
        </div>

        {/* Sponsor name */}
        <h3 className="text-center text-sm font-semibold text-gray-700 dark:text-gray-200 group-hover:text-cycling-orange transition-colors duration-300">
          {sponsor.name}
        </h3>

        {/* Subtle "Visit Website" text that appears on hover */}
        {sponsor.website && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileHover={{ opacity: 1, y: 0 }}
            className="text-xs text-gray-500 dark:text-gray-400 mt-1 group-hover:text-cycling-orange transition-all duration-300"
          >
            Visit Website
          </motion.p>
        )}
      </motion.div>

      {/* Animated border effect */}
      <motion.div
        initial={{ scaleX: 0 }}
        whileHover={{ scaleX: 1 }}
        className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-cycling-orange to-cycling-green origin-left"
      />
    </motion.div>
  );
};

export default SponsorCard;
